import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import { IS_DEV } from '../config';
import storage from 'redux-persist/lib/storage';

// import reducers
import app from './app';
import user, { initialState as userInitialState } from './user';

const MIDDLEWARES = [thunk];

if (IS_DEV || true) {
  MIDDLEWARES.push(createLogger({ collapsed: true }));
}

const reducers = combineReducers({
  app,
  user,
});

const usertTransformer = createTransform(
  (inboundState) => {
    return { tokens: inboundState.tokens };
  },
  (outboundState) => {
    return { ...userInitialState, ...outboundState };
  },
  { whitelist: ['user'] }
);

const defaultTransformer = createTransform(
  (inboundState) => inboundState,
  (outboundState) => outboundState,
  { blacklist: ['user'] }
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
  transforms: [usertTransformer, defaultTransformer],
};

const rootReducer = persistReducer(persistConfig, reducers);

export const store = createStore(rootReducer, applyMiddleware(...MIDDLEWARES));
export const persistor = persistStore(store);
